import axios from 'axios';

const clientAxios = axios.create({
  baseUrl: 'www.google.com', //TODO: Cambiar por variable de entorno process.env.BASE_URL
});

export default clientAxios;
